import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import { route, RouteName } from '../routes';
import {UserType} from "../enum/user/userType";
import {config} from "../libs/config/config";
import {useAuth} from "./useAuth";

export default function useAppRouter() {
  const history = useHistory();
  const { state: { currentUser } } = useAuth();

  const goto = (routeName: RouteName, query: any = undefined, urlParams: any = undefined) => {
    const pathname = route(routeName, urlParams);

    history.push({
      pathname,
      search: query ? qs.stringify(query) : undefined,
    });
  };

  const gotoTopByUser = () => {
    if (currentUser === null) {
      goto('login');
      return;
    }

    switch (currentUser?.userType) {
      case UserType.CUSTOMER:
        if (config.room.page.release.url === undefined) {
          goto('internalServerError');
          throw new Error('ROOMのURLが設定されていません。');
        }

        window.location.href = `${config.room.page.release.url}?to=select`;
        break;
      case UserType.SALESMAN:
        goto('roomList');
        break;
      default:
        throw new Error(`想定外のユーザー（ユーザー種別（${currentUser?.userType}））です。`);
    }
  }

  return { goto, gotoTopByUser };
}
